<template>
  <div class="item-component">
    <div class="s-item-title">
      <h4 class="chart-title">
        <i class="el-icon-s-grid"></i>
        各院系新生人数
      </h4>
    </div>
    <chart-one style="height: 90%" :value="chartData"></chart-one>
  </div>
</template>

<script>
import ChartOne from "../charts/chart01";
import { chartData01 } from "@/assets/json/chartData.js";
import { mapState } from 'vuex';
export default {
  components: {
    ChartOne,
  },
  data() {
    return {
      chartData: [],
      enrollmentYear: "", // 入学年份
    };
  },
  computed:{
    ...mapState('dic',['SUCCESS_CODE','_CURRENTYEAR',"_CURRENT_ACADEMIC"])
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    this.getStudentNum();
  },
  mounted() {},
  methods: {
    // 获取各院系新生人数(男女人数)
    getStudentNum() {
      let params = { enrollmentYear: this.enrollmentYear, academicDegree: this._CURRENT_ACADEMIC };
      this.$http
        .get("/welcome-forecast/statistics/getCollegeStudentNum", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            this.chartData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
